import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["period", "dates"]
  connect() { this.periodChanged() }
  periodChanged() { this.datesTarget.hidden = this.periodTarget.value !== "custom" }
}
